/*

  Login.ts

  Login process for Metskrafl using the Mithril library

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjálmur Þorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

  This UI is built on top of Mithril (https://mithril.js.org), a lightweight,
  straightforward JavaScript single-page reactive UI library.

*/

import { requestWithoutAuth } from "./requestWithoutAuth";
import { GlobalState } from "./globalstate";

// The data returned from the /login_malstadur endpoint
export interface LoginData {
  status: string;
  firebase_token: string;
  user_id: string;
  nickname?: string;
  account: string;
  locale: string;
  new: boolean;
  token: string;
  firebase_api_key: string;
  message?: string;
  prefs: {
    ready: boolean;
    ready_timed: boolean;
    beginner: boolean;
    audio: boolean;
    fanfare: boolean;
    fairplay: boolean;
    email: string;
    full_name: string;
    friend: boolean;
    haspaid: boolean;
  }
}

export const loginUserByEmail = async (
  state: GlobalState,
) => {
  // Call the /login_malstadur endpoint on the server
  // to log in the user with the given email and token.
  // The token is a standard HS256-encoded JWT with aud "netskrafl"
  // and iss typically "malstadur".
  const { userEmail, userNick, userFullname, token } = state;
  return requestWithoutAuth<LoginData>(state, {
    method: "POST",
    url: "/login_malstadur",
    body: { email: userEmail, nickname: userNick, fullname: userFullname, token }
  });
}
